export default {"src":"/_next/static/media/multi-jurisdictional-expertise.69bcdd49.svg","height":1004,"width":1256,"blurWidth":0,"blurHeight":0};